import { render } from "./icon-text.vue?vue&type=template&id=1a1ce883"
import script from "./icon-text.vue?vue&type=script&lang=js"
export * from "./icon-text.vue?vue&type=script&lang=js"

import "./icon-text.vue?vue&type=style&index=0&id=1a1ce883&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__